import Select from 'react-select';
import React from 'react';
import { toast } from 'react-toastify';

const DepartmentModal = ({
    isOpen,
    setIsOpen,
    marquee,
    handleInputChange,
    handleAddAmenities,
    handleStatusChange,
    handleTypeChange,
    TypeOptions,
    statusOptions,
    handleUpdateAmenities
}) => {
    console.log(marquee.status)
    const validateLink = (link) => {
        return link.startsWith("http");
    };
    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" 
        // onClick={() => setIsOpen(false)}
        >
            <div className="custom-modal-content" >
                <h2 className="oms-modal-title">Department</h2>
                <form
                    className="oms-modal-form"
                    onSubmit={(e) => {
                        e.preventDefault();

                       

                        if (marquee.id) {
                            handleUpdateAmenities(); // if editing
                        } else {
                            handleAddAmenities(); // if adding
                        }
                    }}
                      
                >
                    
                    <div className="oms-form-group">
                        <label htmlFor="department_name" className="oms-form-label">Department Name</label>
                        <input
                            type="text"
                            id="department_name"
                            name="department_name"
                            value={marquee.department_name}
                            // onChange={(e) => {
                            //     if (e.target.value.length <= 60) {
                            //         handleInputChange(e);
                            //     }
                            // }}
                            onChange={handleInputChange}
                            placeholder="Enter Department Name"
                            required
                        />
                        {/* <small style={{ fontSize: "12px", color: "gray", float: "right", marginTop: "5px" }}>{marquee.heading.length}/60</small> */}
                    </div>

                
                    <div className="oms-form-group">
                        <label htmlFor="status" className="oms-form-label">
                            Status
                        </label>
                        <Select options={statusOptions}
                            placeholder="Select status"
                            value={statusOptions.find(option => option.value === marquee.status)}
                            onChange={handleStatusChange}

                        />
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
                        <button type="submit">
                            {marquee.id ? "Update" : "Add"}
                        </button>

                    </div>
                </form>
            </div>
        </div>
    );
};

export default DepartmentModal;
